export const LOAD_APPROVAL_LEVELS_STARTED = "LOAD_APPROVAL_LEVELS_STARTED";
export const LOAD_APPROVAL_LEVELS_SUCCESS = "LOAD_APPROVAL_LEVELS_SUCCESS";
export const APPROVAL_LEVEL_UPDATED = "APPROVAL_LEVEL_UPDATED";
export const LOAD_APPROVALS_HISTORY_STARTED = "LOAD_APPROVALS_HISTORY_STARTED";
export const LOAD_APPROVALS_HISTORY_SUCCESS = "LOAD_APPROVALS_HISTORY_SUCCESS";
export const APPROVALS_HISTORY_INVALIDATED = "APPROVALS_HISTORY_INVALIDATED";
export const LOAD_APPROVAL_TYPE_DECISION_REASONS_STARTED = "LOAD_APPROVAL_TYPE_DECISION_REASONS_STARTED";
export const LOAD_APPROVAL_TYPE_DECISION_REASONS_SUCCESS = "LOAD_APPROVAL_TYPE_DECISION_REASONS_SUCCESS";
export const LOAD_APPROVAL_TYPE_DECISION_REASONS_FAILED = "LOAD_APPROVAL_TYPE_DECISION_REASONS_FAILED";
